export class OSVersion {
  public OS: string;
  public OSName: string;
  public BrowserName: string;
  public Version: string;
}
